/**
 * Resolve the PostHog environment name for server-side apps.
 * Reads POSTHOG_ENVIRONMENT, then NODE_ENV. Browser / Next apps that need
 * NEXT_PUBLIC_* vars should wrap this or call resolveEnvironment() directly.
 */
export function posthogEnvironment(): string {
  return (
    process.env['POSTHOG_ENVIRONMENT'] ||
    process.env['NODE_ENV'] ||
    'development'
  );
}

/**
 * Resolve the PostHog environment from an ordered list of candidates.
 * Pass your framework-specific env vars first; the first truthy value wins.
 *
 * @example
 * // Next.js / frontend
 * resolveEnvironment(
 *   process.env.NEXT_PUBLIC_POSTHOG_ENVIRONMENT,
 *   process.env.NEXT_PUBLIC_VERCEL_ENV,
 *   process.env.NODE_ENV,
 * )
 */
export function resolveEnvironment(...candidates: (string | undefined)[]): string {
  return candidates.find(Boolean) ?? 'development';
}

/**
 * Whether to record AI prompt inputs and completion outputs in Vercel AI
 * telemetry spans (recordInputs / recordOutputs). Default on; set
 * POSTHOG_RECORD_AI_IO=0 or false to disable for strict PII environments.
 */
export function shouldRecordAIIO(): boolean {
  const v = process.env['POSTHOG_RECORD_AI_IO'];
  if (v === 'false' || v === '0') return false;
  return true;
}
